import React from 'react';
import './App.css';
import Button from './components/Button/Button';

function App() {
  // Change these values to move or resize the logo
  const logoPosition = { top: '8%', left: '50%' }; // any CSS units (%, px, vw, vh)
  const logoSize = '800%'; // width in px, %, etc.

  return (
    <div className="app">
      {/* Login Button */}
      <div className="login-container">
        <Button variant="primary">Log In</Button>
      </div>

      <header className="app-header">
        <img
          src="/logo.svg"
          alt="Pivot AI Logo"
          className="logo"
          style={{
            position: 'absolute',
            top: logoPosition.top,
            left: logoPosition.left,
            width: logoSize,
            transform: 'translate(-50%, -50%)',
          }}
        />
      </header>
    </div>
  );
}

export default App;